import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'
import { storageLike } from "@/store/pinia.js"

export const authLoginStore = defineStore('authLogin', () => {
    const autoLogin = ref(false);
    const loginInfo = reactive({})

    const changeAutoLogin = (val) => {
        autoLogin.value = val;
    }
    const setLoginInfo = (info) => {
        Object.keys(info).forEach(key => {
            loginInfo[key] = info[key];
        })
    }
    const clearAllAutoLogin = () => {
        return new Promise(resolve => {
            changeAutoLogin(false);
            Object.keys(loginInfo).forEach(key => {
                loginInfo[key] = null;
                delete loginInfo[key];
            })
            resolve()
        })
    }
    return {
        autoLogin,
        loginInfo,
        changeAutoLogin,
        getAutoLoginState: () => autoLogin.value,
        getLoginInfo: () => loginInfo,
        setLoginInfo,
        clearAllAutoLogin
    }
}, {
    persist: {
        storage: storageLike
    },
})